// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".system-in-maintainance[data-v-0ba5b40c]{font-size:180%;color:var(--general-in-maintainance-color)}", ""]);
// Exports
module.exports = exports;
